(function () {
  'use strict';

  /* @ngdoc object
   * @name myPod.sentLeads
   * @description
   *
   */
  angular
    .module('myPod.sentLeads', [
      'ui.router'
    ]);
}());
